export var EmptyNumberFormatter = {
    format: function (decimalValue) {
        return decimalValue.toString();
    }
};
export var EmptyOddFormatters = {
    European: EmptyNumberFormatter,
    Malay: EmptyNumberFormatter,
    Indo: EmptyNumberFormatter,
    Hongkong: EmptyNumberFormatter
};
//# sourceMappingURL=EmptyNumberFormatter.js.map